// extracted by mini-css-extract-plugin
module.exports = {"itemContentRoot":"FeedItemTheme__itemContentRoot--vtvla","itemText":"FeedItemTheme__itemText--37uny"};